module.exports = __webpack_public_path__ + "img/img-3.c5b9944b.webp";